import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e11b6c47"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-req-access" }
const _hoisted_2 = ["disabled", "title", "onClick"]
const _hoisted_3 = {
  key: 0,
  class: "nge-req-access-err",
  role: "alert"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["nge-req-access-btn", { 'is-sent': $setup.state === 'open' && $props.ds.id !== $setup.RETINA_ID && !$setup.retinaFirst }]),
      disabled: $setup.busy,
      title: $setup.title,
      onClick: _withModifiers($setup.ask, ["stop"])
    }, _toDisplayString($setup.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_2),
    ($setup.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($setup.error), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}